import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';
import PageMenu from '../../components/PageMenu';

const styles = css`
  @media (min-width: 992px) {
    background-color: transparent;
    padding: 30px 0 60px 0;
    ul {
      text-align: center;
      li a {
        color: #8A8A8A;
        text-transform: none;
        font-size: 16px;
        &.active {
          color: ${colors.color2};
        }
      }
    }
  }
`;
function MenuGallery({ page, ...props }) {
  const categoryLinks = _.get(page, 'photo_gallery', []).map(g => ({
    name: 'photo-gallery-filtered',
    params: { gallery: _.get(g, 'category_name') },
    title: _.get(g, 'category_name'),
  }));
  return (
    <PageMenu
      {...props}
      className={styles}
      title="Gallery Menu"
      items={[
        {
          name: 'photo-gallery',
          title: 'All Photos',
        },
      ].concat(categoryLinks)}
    />
  );
}
MenuGallery.propTypes = {
  page: PropTypes.object.isRequired,
};
export default MenuGallery;



// WEBPACK FOOTER //
// ./src/pages/PhotoGallery/MenuGalleries.js